module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AgentBuyView.js"));
	}, "AgentBuyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentBuyView!./src/pages/Store/BusinessManage/AgentBuy/AgentBuyView.js
// module id = 1186
// module chunks = 438